module.exports = require("./ak-GH");